import { render, staticRenderFns } from "./classProject.vue?vue&type=template&id=4e70ed9c&"
import script from "./classProject.vue?vue&type=script&lang=js&"
export * from "./classProject.vue?vue&type=script&lang=js&"
import style0 from "./classProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports